<div class="ws-popup-header">
  <div>{{ title | translate }}</div>
  <div class="actions">
    <button (click)="closeClicked()" mat-icon-button>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<div class="ws-popup-content">
  <div class="ws-popup-body">
    <div 
      #accountManagementContainer 
      class="stripe-account-management-container"
      id="stripe-account-management-container">
    </div>
  </div>
</div>

